import { render, staticRenderFns } from "./P.vue?vue&type=template&id=2424d1c6&"
import script from "./P.vue?vue&type=script&lang=ts&"
export * from "./P.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "01ccf70c"
  
)

export default component.exports